import moment from "moment"

export function dateFormatValidator(value: any, params: any[] | Record<string, any>) {
  const format = (params as { [key: string]: string }).format
  return moment(value, format, true).isValid()
}
